import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=12c2df41"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=12c2df41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports